import { useEffect } from "react";
import { CONTACT_INFO } from "@/lib/constants";
import { SERVICES_DATA } from "@/lib/services-data";

const BUSINESS_URL = "https://www.prezmedia.co.uk";

function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${BUSINESS_URL}/#organization`,
    name: "Prez Media",
    url: BUSINESS_URL,
    logo: `${BUSINESS_URL}/favicon.png`,
    image: `${BUSINESS_URL}/favicon.png`,
    description:
      "Luxury cinematic videography for weddings, brands, events, and more. Crafting visual stories that captivate.",
    telephone: CONTACT_INFO.phone,
    email: CONTACT_INFO.email,
    address: {
      "@type": "PostalAddress",
      addressCountry: "GB",
    },
    areaServed: {
      "@type": "Country",
      name: "United Kingdom",
    },
    sameAs: [
      CONTACT_INFO.socials.instagram,
      CONTACT_INFO.socials.youtube,
      CONTACT_INFO.socials.tiktok,
    ],
    priceRange: "££-££££",
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Videography Services",
      itemListElement: SERVICES_DATA.map((s, i) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: s.title,
          url: `${BUSINESS_URL}${s.href}`,
        },
        position: i + 1,
      })),
    },
  };
}

function getWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Prez Media",
    url: BUSINESS_URL,
    potentialAction: {
      "@type": "SearchAction",
      target: `${BUSINESS_URL}/services`,
      "query-input": "required name=search_term_string",
    },
  };
}

/** Injects JSON-LD structured data into <head> for SEO rich snippets. */
export function JsonLd() {
  useEffect(() => {
    const schemas = [getOrganizationSchema(), getWebSiteSchema()];
    const scripts: HTMLScriptElement[] = [];

    schemas.forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    return () => {
      scripts.forEach((s) => s.remove());
    };
  }, []);

  return null;
}
